import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Linha, Interno } from '../../styles/base';

const CardTransporte = ({
  diaSemana, empresa, enderecoAte, enderecoDe, horario, itinerario, linha, observacao,
}) => (
  <div style={{ width: '100%' }}>
    {(linha) && (
    <p style={{
      fontSize: 30, fontWeight: 'bolder', fontStyle: 'italic', color: 'black',
    }}
    >
      {' '}
      {linha}
    </p>
    )}
    {(diaSemana) && (
      <p>
        <span style={{ fontWeight: 'bolder', fontSize: '18px' }}>Dia da Semana:</span>
        {' '}
        {diaSemana}
      </p>
    )}
    {(empresa) && (
    <p>
      <span style={{ fontWeight: 'bolder', fontSize: '18px' }}>Empresa:</span>
        {' '}
      {empresa}
    </p>
    )}
    {(enderecoDe) && (
    <p>
      <span style={{ fontWeight: 'bolder', fontSize: '18px' }}>Endereço De:</span>
        {' '}
      {enderecoDe}
    </p>
    )}
    {(enderecoAte) && (
    <p>
      <span style={{ fontWeight: 'bolder', fontSize: '18px' }}>Endereço Até:</span>
        {' '}
      {enderecoAte}
    </p>
    )}
    {(horario) && (
    <p>
      <span style={{ fontWeight: 'bolder', fontSize: '18px' }}>Horário:</span>
        {' '}
      {horario}
    </p>
    )}
    {(itinerario) && (
    <p>
      <span style={{ fontWeight: 'bolder', fontSize: '18px' }}>Itinerário:</span>
        {' '}
      <div
        style={{
          border: '1px solid #d5d5d5c9', padding: '30px', background: '#ffff0005', marginTop: '20px',
        }}
        dangerouslySetInnerHTML={{ __html: itinerario }}
      />
    </p>
    )}
    {(observacao) && (
    <p style={{ marginTop: '30px', fontSize: '18px' }}>
      <span style={{ fontWeight: 'bolder', display: 'block', marginBottom: '5px' }}>Observações:</span>
        {' '}
      <span style={{ fontSize: '13px' }}>{observacao}</span>
    </p>
    )}
  </div>
);

CardTransporte.propTypes = {
  diaSemana: PropTypes.string,
  empresa: PropTypes.string,
  enderecoAte: PropTypes.string,
  enderecoDe: PropTypes.string,
  horario: PropTypes.string,
  itinerario: PropTypes.string,
  linha: PropTypes.string,
  observacao: PropTypes.string,
};

CardTransporte.defaultProps = {
  diaSemana: '',
  empresa: '',
  enderecoAte: '',
  enderecoDe: '',
  horario: '',
  itinerario: '',
  linha: '',
  observacao: '',
};

export default CardTransporte;
